import { AnomalyLineChartImpl } from '../alertMessage/options';
import { AlertMessageProps } from '../alertMessage/types';

export const options: AlertMessageProps['options'] = {
    cumulative: true,
    dateFormat: {
        autoFormat: false,
        formatString: 'D MMM YYYY, h:mm a',
    },
    lineChart: new AnomalyLineChartImpl(),
    topPosts: {
        enabled: true,
        duration: 15,
        window: 3,
    },
};
